import { Link } from 'react-router-dom';

export const KYCButton = () => {
  return (
    <Link
      className="sticky top-[40px] z-[999] hover:opacity-70 duration-300 py-1 px-4 bg-brand-500 rounded-[23px] text-center text-white text-[20px] font-bold block md-max:w-full w-[200px]"
      target="_blank"
      to="https://kyc-app.amlbot.com/dashboard"
    >
      KYC
    </Link>
  );
};
